// ======================================================================
// File Name       : UserHistoryStudentSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import CustomButton from '../../button/CustomButton';

class UserHistoryStudentSearch extends React.Component {
  render() {
    const {
      groupList,
      groupSecernId,
      dormantState,
      onShowTreeGroupListClick,
      onSearchBtnClick,
      openExportDialog,
      removeSelectedGroup,
      selectedTargetGroup,
      searchCondition,
      dormantUserDataAcquisitionPermissionFlag,
    } = this.props;
    let groupName = null;
    if (searchCondition && searchCondition.selectedTargetGroup) {
      const groupSecernIds = searchCondition.selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernIds, groupList);
    }
    if (selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      const groupSecernIds = selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernIds, groupList);
    }
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="margin-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザー名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="userName" label="ユーザー名" value={null} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザーグループ名
              </Col>
              <Col sm={7}>
                <Button variant="primary" className="btn-96" onClick={onShowTreeGroupListClick}>
                  グループ選択
                </Button>
              </Col>
            </Form.Group>
            {groupName && (
              <Form.Group className="form-info">
                <Col sm={3} />
                <Col sm={7} as={Form.Label} className="padding-left-clear">
                  {groupName}
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96 margin-left-15" onClick={removeSelectedGroup.bind(this)}>
                    削除
                  </Button>
                </Col>
              </Form.Group>
            )}
            {dormantUserDataAcquisitionPermissionFlag && (
              <Form.Group className="form-info">
                <Col sm={10} className="padding-top-10 padding-bottom-10 padding-left-15">
                  <RenderField
                    type="checkbox"
                    name="dormantState"
                    value={dormantState}
                    label="休止状態のユーザーを含む"
                    className="padding-top-clear"
                  />
                </Col>
              </Form.Group>
            )}
          </Col>
          <Form.Group className="text-center">
            <Col sm={12} className='margin-bottom-15'>
              <CustomButton
                btnStyle="btn btn-primary btn-96 margin-top-20"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
              {/* #6578 START */}
              {/* <Button bsStyle="primary" className="btn-96 float-end margin-top-20" onClick={openExportDialog}>
                検索ユーザー学習履歴出力
              </Button> */}
              {/* #6578 END */}
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default UserHistoryStudentSearch;
